module.exports = __webpack_public_path__ + "img/bigtimegaming.d668b299.svg";